import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import formBuilder from './buildForm'
export default class GiftForm extends React.Component {    
    constructor(props) {
        super(props);

    }
    componentDidUpdate(prevProps, prevState){
        let $this = $(ReactDOM.findDOMNode(this));
        formBuilder.gm($this.find('.gift-manager-container'));
    }
    componentDidMount() {
        let $this = $(ReactDOM.findDOMNode(this));
        formBuilder.gm($this.find('.gift-manager-container'));
    }
    render() { 
        let props ={
            "packageId": this.props.packageId,
            "promoId":this.props.promoId,
            "formDisplay": this.props.formDisplay,
            "emailHide": this.props.emailHide,
            "officeRoadHide": this.props.officeRoadHide,
            "officeCityHide": this.props.officeCityHide,
            "stateHide": this.props.stateHide,
            "zipHide":this.props.zipHide,
            "countryHide":this.props.countryHide
        }
        if(!props.formDisplay){
        return null;
        }
        return( 
<div className="gift-manager-wrapping"> 
    <h1 >Gift Manager</h1>
    <h2>Get valuable SALUTRIB<sup>&reg;</sup> coupons for your patients.</h2>
    <div className="gift-manager-container" data-autoSelectGift="true" data-defaultAdd="1" data-onlyUS="false" data-emailNoProfile="true" data-formHide="false" data-packageId={props.packageId} data-promoActivityId={props.promoId} data-tokenId>
    <div id="gm-info-layer" className="gift-manager-header">
        <div id="thank-you">Thank You.</div>
        <div id="service-error">The Gift Manager service is currently unavailable.</div>
        <div id="gm-info-msg"> Please confirm your information:</div>
        <div id="gm-error-msg">There are errors: Please see fields in red below.</div>
    </div>

    <div id="giftManagerElm" className="gift-manager-body">
    <div id="formInfo">
        <div id="emailInfo">
            <GiftInput className="input-group text_field_email" hide={props.emailHide}/>
            <GiftInput className="input-group checkbox_field_1"hide={props.emailHide}/>
        </div>
        <GiftInput className="input-group text-field-office1" hide={props.officeRoadHide}/>
        <GiftInput className="input-group text-field-office2" hide={props.officeRoadHide}/>
        <GiftInput className="input-group text-field-officecity" hide={props.officeCityHide}/>
        <GiftInput className="input-group officestate_field" hide={props.stateHide}/>
        <GiftInput className="input-group office-zip-field" hide={props.zipHide}/>
        <GiftInput className="input-group office-country-field" hide={props.countryHide}/>
    </div>

    <form method="post" action="/activity/gmservice/processorder" id="orderForm">
        <input id="activityHash"  type="hidden" value="" name="gm.program" />
        <input id="packageHash"  type="hidden" value="" name="gm.package" />
        <div id='Giftlist'></div>
        <div id="customGroups"></div>
            <input type="hidden" value="" name="gm.tokenId" id="gm_tokenId" />
            <input type="submit" id="submit_order_button" value="Continue" />
        <div id="hiddenInfo">
            <div id='hiddenInfo_DCs'></div>
            <div id='hiddenInfo_Groups'></div>
        </div>
    </form>
    </div>
</div>

</div>)
    }
}

class GiftInput extends React.Component{
    constructor(props) {
             super(props);     
    }
    render(){
        if(this.props.hide)
            return null;
        return(
            <div className={this.props.className}></div>
            );
    }
}



// WEBPACK FOOTER //
// ./medscape_modules/gift-manager/app.jsx